import React, { useState } from "react";
import { Box, Menu, MenuItem, Typography, TextField } from "@mui/material";
import { ChevronDown } from "lucide-react";
import { SquareArrowUpRight } from "lucide-react-new";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(theme => ({
    container: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: "8px 0",
        borderRadius: "8px",
        transition: "background-color 0.2s",
        margin: "0",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.08)",
        },
    },
    logo: {
        height: "40px",
        width: "auto",
        minWidth: "150px",
        marginRight: "14px",
    },
    chevron: {
        marginLeft: "4px",
        transition: "transform 0.2s",
        color: "#9999A1",
    },
    chevronOpen: {
        transform: "rotate(180deg)",
    },
    menuItem: {
        padding: "8px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "rgba(72, 187, 120, 0.1)",
        },
        "&:focus": {
            backgroundColor: "transparent",
        },
        "&.Mui-focusVisible": {
            backgroundColor: "transparent",
        },
    },
    externalIcon: {
        color: "#9999A1",
        marginRight: "12px",
        flexShrink: 0,
    },
    menuItemLogo: {
        height: "40px",
        width: "auto",
        minWidth: "150px",
        marginRight: "14px",
    },
}));

const AppSwitcher = () => {
    const { classes, cx } = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // Determine OptiFleet URL based on environment
    const getBtcPoolUrl = () => {
        const hostname = window.location.hostname;

        // Check if we're on staging (pool.focuspool.xyz) or dev (localhost)
        if (hostname.includes("focuspool") || hostname === "localhost") {
            return "https://pool.focuspool.xyz/login";
        }

        // Production environment
        return "https://pool.foundrydigital.com/login";
    };

    return (
        <>
            <Box className={classes.container} onClick={handleClick}>
                <img
                    src="/static/zec-logo-white.svg"
                    alt="Test"
                    className={classes.logo}
                />
                <ChevronDown
                    size={20}
                    className={cx(classes.chevron, {
                        [classes.chevronOpen]: open,
                    })}
                />
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    sx: {
                        padding: 0,
                    },
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a1a1a",
                        border: "1px solid rgba(255, 255, 255, 0.12)",
                        borderRadius: "8px",
                        marginTop: "8px",
                        overflow: "hidden",
                    },
                }}
            >
                <MenuItem
                    className={classes.menuItem}
                    component="a"
                    href={getBtcPoolUrl()}
                    onClick={handleClose}
                    sx={{
                        textDecoration: "none",
                        color: "inherit",
                    }}
                >
                    <img src="/static/pool-logo-white.svg" alt="Pool" className={classes.logo} />
                    <SquareArrowUpRight size={20} className={classes.externalIcon} />
                </MenuItem>
            </Menu>
        </>
    );
};

export default AppSwitcher;
